export default "/_next/static/images/faae75c234b2137892ad6a7deb07ace7.jpg";